var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreetingCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 19v-8.93a2 2 0 01.89-1.664L6 7M3 19a2 2 0 002 2h14a2 2 0 002-2M3 19l6.75-4.5M21 19v-8.93a2.001 2.001 0 00-.89-1.664L18 7m3 12l-6.75-4.5m-4.5 0L3 10m6.75 4.5l1.14.76a2 2 0 002.22 0l1.14-.76m0 0L21 10",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.5v-9a1 1 0 00-1-1H7a1 1 0 00-1 1v9",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.455 9.027l-1.68 1.663a1.088 1.088 0 01-1.527-.006L9.554 9.009c-.596-.59-.743-1.523-.285-2.217.628-.953 1.952-1.046 2.726-.279a1.78 1.78 0 012.73.3c.462.697.322 1.628-.27 2.214z",
    fill: "currentColor"
  })));
}
export default SvgGreetingCard;